import { customerIsVsMember } from "../v3/_common/vs-code"
import { VsCodeState } from "../v3/_common/machines/ecommerce-machine/e-commerce-machine-context"

export const encodeVs = (vs: VsCodeState) => (customerIsVsMember(vs) ? "true" : undefined)

export const decodeVs = (encodedVs: string): boolean => encodedVs === "true"
